import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { tagIcons, tagColors } from '../constants/tagConfig';

const SuggestionsContainer = styled.div`
  width: 100%;
  overflow: hidden;
  position: relative;
  margin: -15px 0 15px;
  padding: 4px 0;
  background: rgba(255, 255, 255, 0.03);
  border-radius: 8px;

  &::before,
  &::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    width: 30px;
    pointer-events: none;
    z-index: 1;
  }

  &::before {
    left: 0;
    background: linear-gradient(to right, #E3E3E3 30%, transparent);
  }

  &::after {
    right: 0;
    background: linear-gradient(to left, #E3E3E3 30%, transparent);
  }
`;

const ScrollingContent = styled.div`
  display: flex;
  gap: 12px;
  animation: scrollTags 30s linear infinite;
  padding: 0 180px;
  transform: translateX(0);
  
  &:hover {
    animation-play-state: paused;
  }

  @keyframes scrollTags {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(calc(-50% - 180px)); /* Adjust for left padding */
    }
  }
`;

const ScrollWrapper = styled.div`
  position: relative;
  left: -180px; /* Offset the padding to start from the edge */
  width: calc(100% + 360px); /* Compensate for the negative left position and right space */
`;

const TagPill = styled.button`
  display: flex;
  align-items: center;
  padding: 4px 12px;
  border: 1px solid #d0d0d0;
  border-radius: 16px;
  color: #808080;
  font-family: 'Rubik', sans-serif;
  font-size: 0.85em;
  text-decoration: none;
  white-space: nowrap;
  opacity: 0.7;
  transition: all 0.3s ease;
  background-color: transparent;
  cursor: pointer;

  svg {
    margin-right: 6px;
    font-size: 0.9em;
    color: #808080;
    transition: color 0.3s ease;
  }

  &:hover {
    opacity: 1;
    border-color: ${props => props.color || '#2e2e2e'};
    color: ${props => props.color || '#2e2e2e'};
    background-color: transparent;

    svg {
      color: ${props => props.color || '#2e2e2e'};
    }
  }
`;

const TagSuggestions = ({ onTagClick }) => {
  const [duplicatedTags, setDuplicatedTags] = useState([]);

  useEffect(() => {
    // Get all tags from tagColors
    const allTags = Object.keys(tagColors);
    
    // Duplicate the tags to create a seamless scroll
    setDuplicatedTags([...allTags, ...allTags]);
  }, []);

  return (
    <SuggestionsContainer>
      <ScrollWrapper>
        <ScrollingContent>
          {duplicatedTags.map((tag, index) => {
            const IconComponent = tagIcons[tag];
            return (
              <TagPill
                key={`${tag}-${index}`}
                color={tagColors[tag]}
                onClick={() => onTagClick(tag)}
              >
                {IconComponent && <IconComponent />}
                {tag}
              </TagPill>
            );
          })}
        </ScrollingContent>
      </ScrollWrapper>
    </SuggestionsContainer>
  );
};

export default TagSuggestions; 